import { all, call, put, takeLatest } from "redux-saga/effects";
import { request } from "@app/services";

import * as endpoints from "./endpoints";
import { createOrderFailed, createOrders, createOrderSuccess } from "./slice";

//--------------------CreateOrder-------------------------

function* createOrderSaga({ payload }: ReturnType<typeof createOrders>): any {
  try {
    const response = yield call(request.post, endpoints.createOrder, payload);
    yield put(createOrderSuccess(response.data));
  } catch (error: any) {
    yield put(createOrderFailed(error));
  }
}

//

function* OrderSagas() {
  yield all([takeLatest(createOrders, createOrderSaga)]);
}

export { OrderSagas };
